import { render, staticRenderFns } from "./contentLearnerDeleteGroup.vue?vue&type=template&id=4ba20c6c&"
import script from "./contentLearnerDeleteGroup.vue?vue&type=script&lang=js&"
export * from "./contentLearnerDeleteGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports